<template>
  <SpinnerVue/>
  <ModalVue/>

  <!-- USED FOR DEBUGGING AND FAST NAVIATION -->
   <!-- TODO: REMOVE CODE FOR PRODUCTION`` -->
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/createUser">Create User</router-link> |
    <router-link to="/userAccount">User Account</router-link>
  </nav> -->
  
  <router-view/>
</template>

<script>

import SpinnerVue from '@/components/basicComponents/Spinner.vue';
import ModalVue from '@/components/basicComponents/Modal.vue';


export default {
  name: 'App',
  components: {
    SpinnerVue,
    ModalVue,
  },
  mounted() {
  }
}

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app button {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

html, body {
  display: flex;
  flex-direction: column;
  margin: 0;
  height: 100%
}
</style>
